"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getExportedJSON = exports.getCollapsed = exports.getBanners = exports.getBannerGroupsInBottomRegion = exports.getBannerGroupsInRightRegion = exports.getBannerGroups = exports.getMenus = void 0;

var _reduxOrm = require("redux-orm");

var _orm = _interopRequireDefault(require("./orm"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var getMenus = (0, _reduxOrm.createSelector)(_orm["default"].Menu);
exports.getMenus = getMenus;
var getBannerGroups = (0, _reduxOrm.createSelector)(_orm["default"].Menu.bannerGroups);
exports.getBannerGroups = getBannerGroups;
var getBannerGroupsInRightRegion = (0, _reduxOrm.createSelector)(_orm["default"].Menu.bannerGroups, function (bannerGroups) {
  return bannerGroups.filter(function (bannerGroup) {
    return bannerGroup.region === 'right';
  });
});
exports.getBannerGroupsInRightRegion = getBannerGroupsInRightRegion;
var getBannerGroupsInBottomRegion = (0, _reduxOrm.createSelector)(_orm["default"].Menu.bannerGroups, function (bannerGroups) {
  return bannerGroups.filter(function (bannerGroup) {
    return bannerGroup.region === 'bottom';
  });
});
exports.getBannerGroupsInBottomRegion = getBannerGroupsInBottomRegion;
var getBanners = (0, _reduxOrm.createSelector)(_orm["default"].BannerGroup.banners);
exports.getBanners = getBanners;

var getCollapsed = function getCollapsed(state) {
  return state.MenuBuilderComponent.collapsed;
};

exports.getCollapsed = getCollapsed;

var getExportedJSON = function getExportedJSON(state) {
  return state.MenuBuilderComponent.exportedJSON;
};

exports.getExportedJSON = getExportedJSON;